module.exports = __webpack_public_path__ + "img/vip_room_min_3.63d0b0a8.png";